import { Box, Typography, Divider, Breadcrumbs, Link, Card } from '@mui/material'
import { useRouteQuery, useTranslator } from '@/hooks'
import { Attendances } from '@/@data'
import { useQuery } from '@tanstack/react-query'
import { Button } from "@/@core/components/mui/Button"
import FilterMonthAttendance from '../detail-attendance/FillterMonthAttendance'
import dayjs from 'dayjs'
import { useParams } from 'react-router-dom'
import { useMemo } from 'react'

export const AttendanceEmployeeHistory = ({
  setIsShowHistory,
  dataCompany
}: {
  setIsShowHistory: (isShowHistory: boolean) => void
  dataCompany?: any
}) => {
  const { __, __n } = useTranslator()
  const {id } = useParams()
  const { searchQuery, updateQuery } = useRouteQuery()

  const handleClose = () => {
    setIsShowHistory(false)
  }

  const paramsHistory = {
    userId: Number(id),
    companyId: Number(searchQuery.get('companyId')),
    month: searchQuery.get('month')
  }

  const { data: dataHistory } = useQuery({
    ...Attendances.getConpanyIdEmployeeHistory(paramsHistory),
    enabled: !!searchQuery.get('companyId') && !!searchQuery.get('month') && !!id
  })

  const currentMonthDisplay = useMemo(() => {
    const monthParam = searchQuery.get('month')

    if (monthParam) {
      return dayjs(monthParam).format('MMMM YYYY')
    }

    return dayjs().format('MMMM YYYY')
  }, [searchQuery.get('month')])

  return (
    <>
      <Box>
        <Box
          component={'div'}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 5
          }}
        >
          {<i className='tabler-chevron-left cursor-pointer' onClick={handleClose}></i>}

          <Typography variant='h3'>{__('History Attendance')}</Typography>

          <Divider orientation='vertical' flexItem />

          <Breadcrumbs aria-label='breadcrumb' separator={<i className='tabler-chevron-right' />}>
            <Link color='inherit' href='/cms/attendance'>
              <i className='tabler-home' />
            </Link>
            <Link color='inherit' href='/cms/attendance'>
              {__('Attendance Management')}
            </Link>
            <div className='cursor-pointer text-[#3551f2]' onClick={handleClose}>
              {__('Employee Attendance Detail')}
            </div>
            <Typography sx={{ color: 'text.primary' }}>{__('History Attendance/Payroll')}</Typography>
          </Breadcrumbs>
        </Box>
      </Box>
      <Card sx={{ borderRadius: 4, flex: 1 }}>
        <div className='p-5'>
          <div className='flex justify-between items-center pb-3'>
            <div className='flex items-center gap-3'>
              <Button
                variant='outlined'
                size='small'
                className='border-blue-500 text-blue-600 hover:border-blue-600'
              >
                <span className='text-[15px] font-medium max-w-[500px] whitespace-nowrap overflow-hidden text-ellipsis' title={dataHistory?.data?.user?.first_name || '-'}>
                  {dataHistory?.data?.user?.first_name || '-'}
                </span>
              </Button>
              <Divider orientation='vertical' flexItem className='w-[2px] bg-[#2f2b3d1f]' />
              <Typography variant='h6' className='text-[18px] font-medium'>
                {__('History Attendance/Payroll')}
              </Typography>
            </div>
          </div>
          <div className='text-[15px] text-[#2f2b3d] font-normal'>
            {__("This section stores all changes to the company's employee work schedules and payroll settings.")}
          </div>
        </div>
        <div className='p-5'>
          <FilterMonthAttendance
            onDateChange={month => {
              updateQuery({ month })
            }}
            status={''}
            data={dataCompany || {}}
            isShowSettingDay={true}
          />
        </div>
        <Divider />
        {dataHistory?.data && dataHistory?.data?.attendance_histories?.length > 0 && (
        <div className='p-5'>
          {dataHistory?.data?.attendance_histories?.map((item: any, index: number) => (
            <div key={index} className='border border-[#2f2b3d1f] rounded-[16px] overflow-hidden mb-5 last:mb-0'>
              <div className='flex items-center justify-between p-3 bg-[#2f2b3d1f]'>
                <div className='text-[15px] text-[#2f2b3d] font-medium'>
                  {dayjs(item.created_at).format('DD MMMM YYYY, h:mm A')}
                </div>
                <div className='text-[15px] text-[#2f2b3db3] font-medium'>
                  {item?.created_user?.first_name} - {item?.created_user?.employee_id}
                </div>
              </div>
              <div className='p-5'>
                {/* Payroll */}
                <div className="text-[18px] font-medium text-[#2f2b3d] pb-2">
                  {__('Payroll')} {currentMonthDisplay}
                </div>
                <Divider />
                <div className="grid grid-cols-4 gap-x-3 gap-y-5 mt-3">
                  <div className="flex items-start gap-2">
                    <div>
                      <img src="/images/icons/gross_pay.png" alt="avatar" className="w-[40px] h-[40px]" />
                    </div>
                    <div>
                      <div className="text-[18px] font-medium text-[#2f2b3de6]">
                        {__n(item?.gross_pay)}
                      </div>
                      <div className="text-[13px] font-normal text-[#2f2b3db3]">
                        {__('Gross Pay')}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div>
                      <img src="/images/icons/net_pay.png" alt="avatar" className="w-[40px] h-[40px]" />
                    </div>
                    <div>
                      <div className="text-[18px] font-medium text-[#2f2b3de6]">
                        {__n(item?.net_pay)}
                      </div>
                      <div className="text-[13px] font-normal text-[#2f2b3db3]">
                        {__('Net Pay')}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div>
                      <img src="/images/icons/daily_wage.png" alt="avatar" className="w-[40px] h-[40px]" />
                    </div>
                    <div>
                      <div className="text-[18px] font-medium text-[#2f2b3de6]">
                        {__n(item?.daily_wage)}
                      </div>
                      <div className="text-[13px] font-normal text-[#2f2b3db3]">
                        {__('Daily Wage')}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Attendance */}
                <div className="text-[18px] font-medium text-[#2f2b3d] pb-2 mt-5">
                  {__('Attendance')} {currentMonthDisplay}
                </div>
                <Divider />
                <div className="grid grid-cols-4 gap-x-3 gap-y-5 mt-3">
                  <div className="flex items-start gap-2">
                    <div>
                      <img src="/images/icons/workday.png" alt="avatar" className="w-[40px] h-[40px]" />
                    </div>
                    <div>
                      <div className="text-[18px] font-medium text-[#2f2b3de6]">
                        {__n(item?.working_day)}
                      </div>
                      <div className="text-[13px] font-normal text-[#2f2b3db3]">
                        {__('Workday This Month')}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div>
                      <img src="/images/icons/worked.png" alt="avatar" className="w-[40px] h-[40px]" />
                    </div>
                    <div>
                      <div className="text-[18px] font-medium text-[#2f2b3de6]">
                        {__n(item?.total_working_day)}
                      </div>
                      <div className="text-[13px] font-normal text-[#2f2b3db3]">
                        {__('Worked Day This Month')}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div>
                      <img src="/images/icons/absent.png" alt="avatar" className="w-[40px] h-[40px]" />
                    </div>
                    <div>
                      <div className="text-[18px] font-medium text-[#2f2b3de6]">
                        {__n(item?.absent)}
                      </div>
                      <div className="text-[13px] font-normal text-[#2f2b3db3]">
                        {__('Absent Day This Month')}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div>
                      <img src="/images/icons/none_workday.png" alt="avatar" className="w-[40px] h-[40px]" />
                    </div>
                    <div>
                      <div className="text-[18px] font-medium text-[#2f2b3de6]">
                        {__n(item?.non_working_day)}
                      </div>
                      <div className="text-[13px] font-normal text-[#2f2b3db3]">
                        {__('Non-workday This Month')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          ))}
        </div>
        )}
        {(!dataHistory?.data || dataHistory?.data?.attendance_histories?.length === 0) && (
          <div className='p-5 flex justify-center items-center h-[200px]'>
            <div className='text-[14px] font-normal text-[#2f2b3d]'>
              {__('No data found')}
            </div>
          </div>
        )}
      </Card>
    </>
  )
}
